var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    style: {
      height: 28,
      width: 28,
      marginRight: 8
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.373 17.3204L22.7823 21.7275L22.7823 21.7275C23.0732 22.0184 23.0732 22.4917 22.7786 22.7808C22.6387 22.9227 22.4509 23 22.2503 23C22.0514 23 21.8637 22.9227 21.7219 22.7808L17.3163 18.3738C15.9687 19.4788 14.2842 20.0846 12.5407 20.0846C8.3839 20.0846 5 16.7016 5 12.5414C5 11.5248 5.20067 10.5377 5.59464 9.60771C5.97572 8.70902 6.52067 7.9024 7.21287 7.20994C7.90507 6.51747 8.71142 5.97419 9.60984 5.59299C10.5395 5.19889 11.5263 5 12.5425 5C16.6994 5 20.0833 8.38301 20.0833 12.5432C20.0833 14.2854 19.4776 15.9724 18.373 17.3204ZM12.5427 18.5913C15.8768 18.5913 18.5904 15.8786 18.5904 12.5416C18.5904 9.20633 15.8768 6.4918 12.5427 6.4918C9.20856 6.4918 6.49494 9.20633 6.49494 12.5416C6.49494 15.8768 9.20677 18.5913 12.5427 18.5913Z",
    fill: "#888888"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4af99dbaeccb2da0fd1a70ab9b39c86c.svg";
export { ForwardRef as ReactComponent };